import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { APIResponse } from "../types/Common";
import { STATUS_CODES } from "@src/config/constant";
import CommissionService from "@src/services/CommissionService";


const commission = createSlice({
    name: 'commission',
    initialState: {
        commissionList: [],
    },
    reducers: {
        commissionList: (state, action) => {
            state.commissionList = action.payload
        }
    }
})


export default commission.reducer


const {  commissionList } = commission.actions

export const getCommissionList = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommissionService.getCommissionPointList(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response.data)
                        // dispatch(commissionList(response.data));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const getCommissionDetail = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommissionService.getCommissionPointDetails(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response.data)
                        // dispatch(commissionList(response.data));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

